





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { LineItemViewObject } from '@/types/apiServerContract';

@Component({
    components: { }
})
export default class CheckoutOrderSummaryLineItem extends Vue {
    @Prop(Boolean)
    isErpAvailable!: boolean;

    @Prop(Object)
    lineItem!: LineItemViewObject;

    formatDutyDescription(dutyText) {
        return `(${dutyText.toLowerCase()})`;
    }

    get hasOriginalPrice() {
        return this.lineItem.originalTotal !== null && this.lineItem.originalTotal !== undefined;
    }
}
